<p-fieldset
    [legend]="legend() | translate"
    [toggleable]="toggleable()"
    [collapsed]="collapsed()"
    (collapsedChange)="collapsed.set($event)">
    <ng-template #expandicon>
        <p-toggleswitch [ngModel]="collapseValue" readonly="true" />
    </ng-template>
    <ng-template #collapseicon>
        <p-toggleswitch [ngModel]="expandValue" readonly="true" />
    </ng-template>
    <ng-content></ng-content>
</p-fieldset>
